document.addEventListener('DOMContentLoaded', function() {
  // This javascript file is used to the calculation of the "Dimensionering af olieudskiller" page.
  let isSwedishDomain = window.location.hostname.toLowerCase().endsWith('.se');
  let specialSeparatorText = isSwedishDomain ? 'Specialtillverkad' : 'Speciallavet';
  let installationText = isSwedishDomain ? 'Välj installation...' : 'Vælg installation...';

  function calculateOlieudskiller() {
    // Input variables:
    let hoejtryksrenser = parseFloat(document.querySelector('.custom-input-item.active input.hojtryksrenser')?.value) || 0;
    let gulvafloeb = parseFloat(document.querySelector('.custom-input-item.active input.gulvafloeb')?.value) || 0;
    let haandvaske = parseFloat(document.querySelector('.custom-input-item.active input.haandvaske')?.value) || 0;
    let rengoeringsvaske = parseFloat(document.querySelector('.custom-input-item.active input.rengoeringsvaske')?.value) || 0;
    let vaskekar = parseFloat(document.querySelector('.custom-input-item.active input.vaskekar')?.value) || 0;
    let vaskekarL = parseFloat(document.querySelector('.custom-input-item.active input.vaskekarL')?.value) || 0;
    let tapventil15 = parseFloat(document.querySelector('.custom-input-item.active input.tapventil15')?.value) || 0;
    let tapventil20 = parseFloat(document.querySelector('.custom-input-item.active input.tapventil20')?.value) || 0;
    let tapventil25 = parseFloat(document.querySelector('.custom-input-item.active input.tapventil25')?.value) || 0;

      // Debug: Log all input variables
      console.log('Inputs:', {
        hoejtryksrenser, gulvafloeb, haandvaske, rengoeringsvaske, vaskekar, vaskekarL,
        tapventil15, tapventil20, tapventil25
      });
    
    let hoejtryksrenserOutput;
    if (hoejtryksrenser === 0) {
      hoejtryksrenserOutput = 0;
    } else if (hoejtryksrenser === 1) {
      hoejtryksrenserOutput = 2;
    } else if (hoejtryksrenser === 2) {
      hoejtryksrenserOutput = 3;
    } else if (hoejtryksrenser === 3) {
      hoejtryksrenserOutput = 4;
    } else if (hoejtryksrenser === 4) {
      hoejtryksrenserOutput = 5;
    } else if (hoejtryksrenser >= 5) {
      hoejtryksrenserOutput = 5 + ((hoejtryksrenser - 4) * 1);
    }
      console.log('hoejtryksrenserOutput:', hoejtryksrenserOutput);


    let gulvafloebOutput;
    if (gulvafloeb === 0) {
      gulvafloebOutput = 0;
    } else if (gulvafloeb >= 1) {
      gulvafloebOutput = 0.4 * gulvafloeb;
    }

      console.log('gulvafloebOutput:', gulvafloebOutput);


    let haandvaskeOutput;
    if (haandvaske === 0) {
      haandvaskeOutput = 0;
    } else if (haandvaske >= 1) {
      haandvaskeOutput = 0.4 * haandvaske;
    }

      console.log('haandvaskeOutput:', haandvaskeOutput);


    let rengoeringsvaskeOutput;

    if (rengoeringsvaske === 0) {
      rengoeringsvaskeOutput = 0;
    } else if (rengoeringsvaske >= 1) {
      rengoeringsvaskeOutput = 0.6 * rengoeringsvaske;
    }

      console.log('rengoeringsvaskeOutput:', rengoeringsvaskeOutput);

    let vaskekarOutput;

    if (vaskekarL > 0) {
      vaskekarOutput = 2 * vaskekarL;
    } else if (vaskekar === 0) {
      vaskekarOutput = 0;
    } else if (vaskekar >= 1) {
      vaskekarOutput = 0.9 * vaskekar;
    }

      console.log('vaskekarOutput:', vaskekarOutput);


    let tapventil15Output;
    if (tapventil15 === 0) {
      tapventil15Output = 0;
    } else if (tapventil15 === 1) {
      tapventil15Output = 0.5;
    } else if (tapventil15 === 2) {
      tapventil15Output = 1;
    } else if (tapventil15 === 3) {
      tapventil15Output = 1.35;
    } else if (tapventil15 === 4) {
      tapventil15Output = 1.6;
    } else if (tapventil15 >= 5) {
      tapventil15Output = 1.6 + ((tapventil15 - 4) * 0.1);
    }

      console.log('tapventil15Output:', tapventil15Output);

    let tapventil20Output;
    if (tapventil20 === 0) {
      tapventil20Output = 0;
    } else if (tapventil20 === 1) {
      tapventil20Output = 1;
    } else if (tapventil20 === 2) {
      tapventil20Output = 2;
    } else if (tapventil20 === 3) {
      tapventil20Output = 2.7;
    } else if (tapventil20 === 4) {
      tapventil20Output = 3.2;
    } else if (tapventil20 >= 5) {
      tapventil20Output = 3.2 + ((tapventil20 - 4) * 0.2);
    }

      console.log('tapventil20Output:', tapventil20Output);

    let tapventil25Output;
    if (tapventil25 === 0) {
      tapventil25Output = 0;
    } else if (tapventil25 === 1) {
      tapventil25Output = 1.7;
    } else if (tapventil25 === 2) {
      tapventil25Output = 3.4;
    } else if (tapventil25 === 3) {
      tapventil25Output = 4.6;
    } else if (tapventil25 === 4) {
      tapventil25Output = 5.45;
    } else if (tapventil25 >= 5) {
      tapventil25Output = 5.45 + ((tapventil25 - 4) * 0.3);
    }

      console.log('tapventil25Output:', tapventil25Output);

    let regnvand = document.querySelector('#regnvand');
    let regnvandAreal = 0;
    let regnvandIntensitet = 0;
    if (regnvand && regnvand.value === 'ja') {
      regnvandAreal = parseFloat(document.querySelector('#arealbelaegning')?.value) || 0;
      regnvandIntensitet = parseFloat(document.querySelector('#regnhaendelse')?.value) || 0;
    }

      console.log('regnvandAreal:', regnvandAreal, 'regnvandIntensitet:', regnvandIntensitet);

    let spildevand = document.querySelector('#spildevand');
    let spildevandFaktor = 0;
    if (spildevand && spildevand.value === 'ja') {
      spildevandFaktor = hoejtryksrenserOutput + gulvafloebOutput + haandvaskeOutput + rengoeringsvaskeOutput + vaskekarOutput + tapventil15Output + tapventil20Output + tapventil25Output;
    } else {
      spildevandFaktor = 0;
    }

      console.log('spildevandFaktor:', spildevandFaktor);

    let emulgering = parseFloat(document.querySelector('#emulgering')?.value) || 0;
    let klimafaktor = parseFloat(document.querySelector('#klimafaktor')?.value) || 0;
    let udskillerEffekt = parseFloat(document.querySelector('#udskiller')?.value) || 0;
    let massefylde = parseFloat(document.querySelector('#massefylde')?.value) || 0;
    let massefyldeOutput;
    if (udskillerEffekt === 1) {
      massefyldeOutput = massefylde;
    } else {
      if (massefylde === 1) {
        massefyldeOutput = 1;
      } else if (massefylde === 2) {
        massefyldeOutput = 1.5;
      } else if (massefylde === 3) {
        massefyldeOutput = 2;
      }
    }
    let slam = parseFloat(document.querySelector('#slammaengde')?.value) || 0;

      console.log('emulgering:', emulgering, 'klimafaktor:', klimafaktor, 'udskillerEffekt:', udskillerEffekt, 'massefylde:', massefylde, 'massefyldeOutput:', massefyldeOutput, 'slam:', slam);

    // Total output calculation
    let regnvandsStroem = regnvandAreal * regnvandIntensitet;
    let klimafaktorOutput = klimafaktor * regnvandsStroem;
    let oliefaktor = klimafaktorOutput * massefyldeOutput;
    let emulgering1;
    let emulgering2;
    if (emulgering === 0) {
      emulgering1 = 1;
    } else {
      emulgering1 = emulgering;
    }
    if (emulgering < 2) {
      emulgering2 = 2;
    } else {
      emulgering2 = emulgering;
    }
    let emulgeringfaktor = emulgering1 + emulgering2;
    let oliefakturOutput;
    if (massefyldeOutput > 1.5) {
      oliefakturOutput = 1.5;
    } else {
      oliefakturOutput = massefyldeOutput;
    }

      console.log('regnvandsStroem:', regnvandsStroem);
      console.log('klimafaktorOutput:', klimafaktorOutput);
      console.log('oliefaktor:', oliefaktor);
      console.log('emulgering1:', emulgering1, 'emulgering2:', emulgering2, 'emulgeringfaktor:', emulgeringfaktor);
      console.log('oliefakturOutput:', oliefakturOutput);

    let addon;
    let spildevandFallback;
    if (spildevandFaktor === 0) {
      spildevandFallback = 1;
    } else {
      spildevandFallback = spildevandFaktor;
    }
    if (emulgering === 0 && spildevandFaktor === 0) {
      addon = 0;
    } else if (massefyldeOutput != 0) {
      addon = emulgering * spildevandFallback * massefyldeOutput;
    }

      console.log('spildevandFallback:', spildevandFallback, 'addon:', addon);

    let finalOne = addon + oliefaktor;

    console.log('finalOne:', finalOne);


    // Defining output variables
    let outputOne = document.querySelector('#total-output-one');
    let outputTwo = document.querySelector('#total-output-two');
    let outputThree = document.querySelector('#total-output-three');


    // Showing output calculations
    if (outputOne) {
      outputOne.textContent = finalOne.toFixed(2) + ' L/s';
        console.log('OutputOne (finalOne):', finalOne.toFixed(2) + ' L/s');
    }
    let qudNS;
    if (outputTwo) {
      if (finalOne > 0 && finalOne <= 3) {
        qudNS = '3';
      } else if (finalOne > 3 && finalOne <= 6) {
        qudNS = '6';
      } else if (finalOne > 6 && finalOne <= 10) {
        qudNS = '10';
      } else if (finalOne > 10 && finalOne <= 15) {
        qudNS = '15';
      } else if (finalOne > 15 && finalOne <= 20) {
        qudNS = '20';
      } else if (finalOne > 20 && finalOne <= 30) {
        qudNS = '30';
      } else if (finalOne > 30 && finalOne <= 40) {
        qudNS = '40';
      } else if (finalOne > 40 && finalOne <= 50) {
        qudNS = '50';
      } else if (finalOne > 50 && finalOne <= 60) {
        qudNS = '60';
      } else if (finalOne > 60 && finalOne <= 70) {
        qudNS = '70';
      } else if (finalOne > 70 && finalOne <= 80) {
        qudNS = '80';
      } else if (finalOne > 80 && finalOne <= 90) {
        qudNS = '90';
      } else if (finalOne > 90 && finalOne <= 100) {
        qudNS = '100';
      } else if (finalOne > 100) {
        qudNS = specialSeparatorText;
      }
      outputTwo.textContent = qudNS;
    }

    if (outputThree) {
      let slambelastning = (qudNS * slam) / oliefakturOutput;
      outputThree.textContent = slambelastning + ' L';
    }

    // Product recommendation from calculation
    let products = document.querySelectorAll('.product-recommendation-item');
    let fallbackProduct = document.querySelector('.no-product-recommendation-item');

    let bestProduct = null;
    let bestInterval = Infinity; // Start with Infinity since we want the lowest intervalValue above qud


    products.forEach(function(product, idx) {
      product.classList.forEach(function(className) {
        let match = className.match(/^interval-(\d+)$/);
        if (match) {
          let intervalValue = parseInt(match[1], 10);
          if (intervalValue >= qudNS && intervalValue < bestInterval) {
            bestInterval = intervalValue;
            bestProduct = product;
          }
        }
      });
    });

    console.log('Best interval found:', bestInterval);
    console.log('Best product:', bestProduct);

    // Hide all products first using the 'hidden' class
    products.forEach(function(product) {
      product.classList.add('hidden');
      product.classList.remove('chosen');
    });
    if (fallbackProduct) {
      fallbackProduct.classList.add('hidden');
      fallbackProduct.classList.remove('chosen');
    }

    // Show the best matching product, or fallback if none found
    if (bestProduct) {
      console.log('Showing bestProduct');
      bestProduct.classList.remove('hidden');
      bestProduct.classList.add('chosen');
      let sendButton = document.querySelector('.custom-send-formula-button');
      if (sendButton) {
        sendButton.classList.add('active');
      }
    } else if (fallbackProduct) {
      console.log('Showing fallbackProduct');
      fallbackProduct.classList.remove('hidden');
      fallbackProduct.classList.add('chosen');
      let sendButton = document.querySelector('.custom-send-formula-button');
      if (sendButton) {
        sendButton.classList.add('active');
      }
    }

  }

  let submitButton = document.querySelector('#submit-calculation-olie');
  if (submitButton) {
    submitButton.addEventListener('click', function(event) {
      event.preventDefault();
      calculateOlieudskiller();
    });
  }

  // Custom input selector logic
  // Helper: Get all selected option data-ids
  function getAllSelectedIds() {
    return Array.from(document.querySelectorAll('.custom-dropdown-selected[data-selected-id]'))
      .map(sel => sel.getAttribute('data-selected-id'))
      .filter(Boolean);
  }

  // Helper: Update all dropdowns to mark used options
  function updateDropdownOptions() {
    const usedIds = getAllSelectedIds();
    document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
      dropdown.querySelectorAll('.custom-option').forEach(option => {
        if (
          usedIds.includes(option.dataset.id) &&
          dropdown.querySelector('.custom-dropdown-selected').getAttribute('data-selected-id') !== option.dataset.id
        ) {
          option.classList.add('used');
        } else {
          option.classList.remove('used');
        }
      });
    });
  }

  // Initialize a dropdown (attach events)
  function initDropdown(dropdown) {
    const selected = dropdown.querySelector('.custom-dropdown-selected');
    const options = dropdown.querySelector('.custom-dropdown-options');
    const optionSpans = options.querySelectorAll('.custom-option');
    const row = dropdown.closest('.custom-input-selector-row');
    const inputsList = row.querySelector('.custom-inputs-list');
    const inputItems = inputsList.querySelectorAll('.custom-input-item');

    // Open/close
    selected.addEventListener('click', function(e) {
      e.stopPropagation();
      dropdown.classList.toggle('open');
    });

    // Option click
    optionSpans.forEach(function(option) {
      option.addEventListener('click', function(e) {
        if (option.classList.contains('used')) {
          e.stopPropagation();
          e.preventDefault();
          return;
        }
        e.stopPropagation();
        // Set selected text and data
        selected.textContent = option.textContent;
        selected.setAttribute('data-selected-id', option.dataset.id);
        optionSpans.forEach(opt => opt.classList.remove('active'));
        option.classList.add('active');
        dropdown.classList.remove('open');
        // Show only the matching input, reset others to 0
        inputItems.forEach(item => {
          if (item.dataset.id === option.dataset.id) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
            // Reset input value to 0 when hidden
            const input = item.querySelector('input');
            if (input) input.value = '0';
          }
        });
        updateDropdownOptions();
      });
    });

    // Allow clearing selection by double-clicking selected
    selected.addEventListener('dblclick', function(e) {
      e.stopPropagation();
      selected.textContent = 'Vælg enhed...';
      selected.removeAttribute('data-selected-id');
      optionSpans.forEach(opt => opt.classList.remove('active'));
      inputItems.forEach(item => {
        item.classList.remove('active');
        // Reset input value to 0 when deselected
        const input = item.querySelector('input');
        if (input) input.value = '0';
      });
      updateDropdownOptions();
    });
  }

  // Only one document click handler!
  document.addEventListener('click', function(e) {
    // If the click is on a used option, do nothing and keep dropdown open
    if (
      e.target.classList &&
      e.target.classList.contains('custom-option') &&
      e.target.classList.contains('used')
    ) {
      e.stopPropagation();
      e.preventDefault();
      return;
    }
    // Otherwise, close all dropdowns
    document.querySelectorAll('.custom-dropdown.open').forEach(function(dropdown) {
      dropdown.classList.remove('open');
    });
  });

  // Initialize all dropdowns on page load
  document.querySelectorAll('.custom-dropdown').forEach(initDropdown);

  // Add new dropdown on button click
  const addButton = document.getElementById('add-custom-input-selector-olie');
  if (addButton) {
    addButton.addEventListener('click', function() {
      const firstRow = document.querySelector('.custom-input-selector-row');
      if (!firstRow) return;
      const newRow = firstRow.cloneNode(true);
      // Reset selection in new row
      const selected = newRow.querySelector('.custom-dropdown-selected');
      if (selected) {
        selected.textContent = installationText;
        selected.removeAttribute('data-selected-id');
      }
      newRow.querySelectorAll('.custom-option').forEach(opt => {
        opt.classList.remove('active', 'used');
      });
      newRow.querySelectorAll('.custom-input-item').forEach(item => {
        item.classList.remove('active');
        // Optionally clear input values:
        const input = item.querySelector('input');
        if (input) input.value = '';
      });
      // Attach events
      const dropdown = newRow.querySelector('.custom-dropdown');
      if (dropdown) initDropdown(dropdown);
      // Insert before the add button
      const group = document.getElementById('custom-input-selector-group');
      if (group) group.insertBefore(newRow, addButton);
      updateDropdownOptions();
    });
  }

  function toggleRegnvandContainer() {
    const regnvand = document.querySelector('#regnvand');
    const container = document.querySelector('.regnvand-container');
    if (!container || !regnvand) return;
    if (regnvand.value === 'ja') {
      container.style.display = '';
    } else {
      container.style.display = 'none';
    }
  }

  const regnvandInput = document.querySelector('#regnvand');
  if (regnvandInput) {
    regnvandInput.addEventListener('change', toggleRegnvandContainer);
    toggleRegnvandContainer();
  }

  // Initial update
  updateDropdownOptions();




});